module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/philosophy01_sp-e06fe7ff85900f79f9d05384e1ea6014.png";